import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CertificateIcon } from './certificate-icon';
import classNames from 'classnames';
import './styles.less';
import { Button, Spin } from 'antd';

const Certificate = ( { isEarned, fetchCertificateUrl, className, children } ) => {

    const [ loading, setLoading ] = useState( false );

    async function getUrl() {
        if ( loading ) {return;}
        setLoading( true );
        const url = await fetchCertificateUrl();
        window.open( url, '_newtab' );
        setLoading( false );
    }

    return ( loading ? <Spin className='cert-spin' /> :
        ( <div className={ classNames( 'cert-icon', { 'earned': isEarned }, className ) } >
            <Button
                disabled={ !isEarned }
                onClick={ getUrl }>
                <CertificateIcon />
                { children }
            </Button>
        </div> ) );
};

Certificate.propTypes = {
    isEarned: PropTypes.bool.isRequired,
    fetchCertificateUrl: PropTypes.func.isRequired,
    className: PropTypes.string,
};

Certificate.defaultProps = {
    className: '',
};

export default Certificate; 